

(async () => {
    if (!window.location.pathname.includes("/collections/")) return;
    
    const hostBar = document.querySelector("sc-dynamic-compare");  
    if(!hostBar) return;
    const defStyles = document.querySelectorAll('style[data-shopify]');
    hostBar.shadowRoot.querySelector('.floating-compare-bar')?.classList.add('page-width');


    defStyles.forEach((styleTag) => {
      const sheet = new CSSStyleSheet();
      sheet.replaceSync(styleTag.textContent);
      hostBar.shadowRoot.adoptedStyleSheets.push(sheet); 
    })


    const hostDialogue = document.querySelector("sc-dynamic-compare-dialog");  
    if(!hostDialogue) return;
    const titleEl = hostDialogue.shadowRoot?.querySelector(".compare-dialog__heading");
    titleEl && (titleEl.innerHTML = 'Technische Daten im Vergleich');  

    const compareSpan = document.createElement('span')
    compareSpan.classList.add('compare-span');
    const container = hostBar.shadowRoot.querySelector('.floating-compare-bar__product-list');
    container && container.appendChild(compareSpan);

    const compareBtn = hostBar.shadowRoot.querySelector('sc-compare-dialog-open-button button')
    const clearBtn = hostBar.shadowRoot.querySelector('sc-compare-clear-button button')

    const compareTableHeading = hostDialogue.shadowRoot.querySelector('.compare-dialog__heading');

    compareBtn && (compareBtn.innerText = `${window.compareTableTranslations.compareBtnLabel}`);
    clearBtn && (clearBtn.innerText = `${window.compareTableTranslations.compareClearBtnLabel}`);
    compareTableHeading && (compareTableHeading.innerText = `${window.compareTableTranslations.compareTableTitle}`);


    await fetch("//biberger.de/cdn/shop/t/112/assets/compare-table-bar-styles.css?v=24189710392206598481769772283")
      .then(res => res.text())
      .then(css => {
        const sheet = new CSSStyleSheet();
        sheet.replaceSync(css);
        hostBar.shadowRoot.adoptedStyleSheets.push(sheet); 
    });


    await fetch("//biberger.de/cdn/shop/t/112/assets/compare-table-styles.css?v=129761125414942475101769772284")
      .then(res => res.text())
      .then(css => {
        const sheet = new CSSStyleSheet();
        sheet.replaceSync(css);
        hostDialogue.shadowRoot.adoptedStyleSheets.push(sheet); 
    });



    setInterval(() => {
      const dynamicCompareInstance = document.querySelector('sc-dynamic-compare');
      if(!dynamicCompareInstance) return;
      const count = dynamicCompareInstance.getCount();
      const span = container.querySelector('.compare-span')

      span && (span.innerText = `${window.compareTableTranslations.compareCounterLabel} ${count}/10`);

    }, 1000)



    let errorVisible = false;

    setInterval(() => {
      const dynamicCompareDialog = document.querySelector("sc-dynamic-compare-dialog");
      const dynamicCompareError = dynamicCompareDialog
        ?.shadowRoot?.querySelector(".compare-dialog__error");

      if (dynamicCompareError && !errorVisible) {
        console.log("Error appeared, reopening modal");

        errorVisible = true;

        dynamicCompareDialog?.close();
        dynamicCompareDialog?.showModal();
      }

      if (!dynamicCompareError && errorVisible) {
        console.log("✅ Error cleared");
        errorVisible = false;
      }
    }, 500);
})()